module.exports = __webpack_public_path__ + "static/aaron_gasperi-cbeff96d927790b0a4ad7507ace08fe5.jpg";